module.exports = __webpack_public_path__ + "static/media/valentino-umo-big.614d0901.png";